import { useState, useEffect, useRef } from 'react';
import { getAll } from '../../../service/operacion/CambioLada';
import { UserModel } from '../../../modules/auth/models/UserModel';
import { SimpleAlert } from '../../../../_mexablock/helpers';

type Status = 'idle' | 'loading' | 'success' | 'error';

export const useGetAll = (reloadGrid: number, filters: any) => {
  const [data, setData] = useState<UserModel[]>([]);
  const [status, setStatus] = useState<Status>('idle');
  const requestIdRef = useRef(0);

  useEffect(() => {
    if (!reloadGrid) return;

    const run = async () => {
      const requestId = ++requestIdRef.current;
      setStatus('loading');

      try {
        const res = await getAll(filters);

        if (requestId !== requestIdRef.current) return;

        setData(res?.rows ?? []);
        setStatus('success');
      } catch (error: any) {
        if (requestId !== requestIdRef.current) return;

        setStatus('error');

        const message =
          error?.response?.data?.message ||
          'Ocurrió un error al cargar la información';

        SimpleAlert(message, 3000, 'error');
      }
    };

    run();
  }, [reloadGrid, filters]);

  return {
    data,
    loading: status === 'loading',
    status,
  };
};

export const useGetOne = (id: number) => {
  const currentDate = new Date();
  const fechaMaxima = new Date(currentDate);
  fechaMaxima.setFullYear(currentDate.getFullYear() - 18);

  const initModel = {
    id: 0,
    alias: '',
    first_name: '',
    father_last_name: '',
    mother_last_name: '',
    email: '',
    phone: '',
    phoneFormat: '',
    birthdate: fechaMaxima,
    active: false,
    gender: {
      id: 0,
      code: 'SEL',
      name: 'Seleccione',
    },
  };
  const [initValues, setInitValues] = useState<UserModel>(initModel);
  // const history = useHistory();
  // useEffect(() => {
  //   const fetchPost = async () => {
  //     const res = await getOneSocios(id)
  //       .then()
  //       .catch((error) => {
  //         history.push('/error/500');
  //       });
  //     if (res) {
  //       setInitValues(res);
  //     }
  //   };
  //   if (id) {
  //     fetchPost();
  //   } else {
  //     setInitValues(initModel);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [id]);
  return { initValues };
};